import React from 'react'

import './index.scss'

interface SectionRequired {
	children: React.ReactNode
}

interface SectionOptional {
	className?: string
}

interface ISectionProps extends SectionRequired, SectionOptional {}

const Section: React.FC<ISectionProps> = ({ className = '', children }) => (
	<section className={`section-wrapper ${className}`}>{children}</section>
)

export default Section
